import 'jquery'
import 'common'
import 'Header'
import 'sass/layout.scss'
import '../api/api'
import { render } from "../api/render";
import { WOW } from 'wowjs'
// import {aTargetAttr} from "../utils/utils";//公司项目常用插件
// import {throttle} from "../utils/utils";//公司项目常用插件
// import '../lib/swiper/swiper.jquery'//各种轮播SWIPER插件
// import '../lib/fancybox/jquery.fancybox' //弹窗插件
// import Map from "../lib/map/map";//地图插件
// import "../lib/mCustomScrollbar/jquery.mCustomScrollbar.concat.min" //自定义滚动条插件

//以下三个为屏幕位置响应动画组合插件
// import '../lib/jquery.easing.1.3'
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
//屏幕位置响应动画组合插件结束

$(function () {


    const bannerSwiper = () => {
        let swiper_index = 0,
            timer = null,
            interval = null,
            prev_status = null,
            prev_outTime = null,
            prev_index = 0,
            prev_first_status = true,
            swiper_btn = null,
            next_status = null,
            Interval_time = null;

        document.documentElement.style.setProperty('--height', $(window).height() + 'px');
        document.documentElement.style.setProperty('--width', $(window).width() + 'px');


        //初始化顺序
        let li_length = $(".indexSwiperBox li").length;
        $('.total').text(li_length)
        for (let index = 0; index < li_length; index++) {
            $(".indexSwiperBox").find('li').eq(index).css('z-index', li_length - index);
        }
        autoPlay();


        // 自动轮播
        function autoPlay() {
            interval = setInterval(() => {
                for (let index = 0; index < li_length; index++) {
                    if (swiper_index == 0) {
                        $(".indexSwiperBox").find('li').eq(index).css('z-index', li_length - index);
                    } else {
                        if (swiper_index > index) {
                            $(".indexSwiperBox").find('li').eq(index).css('z-index', - index);
                        } else {
                            $(".indexSwiperBox").find('li').eq(index).css('z-index', li_length - index);
                        }
                    }

                    if (index == li_length - 1) {
                        Interval_time = setTimeout(() => {
                            $(".indexSwiperBox").find('li').removeClass('prev_active');
                            clearTimeout(Interval_time);
                            Interval_time = null;

                            if (swiper_index > li_length - 1) swiper_index = 0;
                            $(".indexSwiperBox").find('li').eq(swiper_index).addClass('next_active');
                            if (swiper_index + 1 < li_length) {
                                $(".indexSwiperBox").find('li').eq(swiper_index + 1).addClass('img_scale');
                                $('.index').text(swiper_index + 2)
                            } else {
                                $(".indexSwiperBox").find('li').eq(0).addClass('img_scale');
                                $('.index').text(1)
                            }

                            $(".prev_btn").add($(".next_btn")).addClass('no_click');
                            timer = setTimeout(() => {
                                $(".indexSwiperBox").find('li').removeClass('next_active');
                                $(".indexSwiperBox").find('li').eq(swiper_index).removeClass('img_scale');
                                swiper_index++;
                                if (swiper_index == li_length) swiper_index = 0;
                                clearTimeout(timer);
                                timer = null;
                                swiper_btn = 'next';
                                for (let index = 0; index < li_length; index++) {
                                    if (swiper_index == 0) {
                                        $(".indexSwiperBox").find('li').eq(index).css('z-index', li_length - index);
                                    } else {
                                        if (swiper_index > index) {
                                            $(".indexSwiperBox").find('li').eq(index).css('z-index', - index);
                                        } else {
                                            $(".indexSwiperBox").find('li').eq(index).css('z-index', li_length - index);
                                        }
                                    }
                                }
                                $(".prev_btn").add($(".next_btn")).removeClass('no_click');
                            }, 1000);

                        }, 100);
                    }
                }

            }, 5000);
        }
    }

    const getBannerData = () => {
        Promise.all([
            api.getRows({ categoryId: 409, title_en: 1 }),
            api.getRows({ categoryId: 408, title_en: 1, content_en: 1, content: 1, big_img: 1 }),
        ]).then(res => {
            let banner = { list: res[0].data };
            let data = { list: res[1].data };
            render('indexSwiperBoxTmp', 'indexSwiperBox', banner);
            render('index_brandBoxTmp', 'index_brandBox', data);
            bannerSwiper();
            slideScreen();
            loading.hide();
            setTimeout(() => {
                new WOW({
                    live: true, callback: function (box) {
                        $(box).removeClass('wow')
                    }
                }).init();
                getContentData();
            }, 500);

            //下滑一屏
            function slideScreen() {
                $(".indexSwiperBox .icon-iconset0413").click(function () {
                    var height = window.innerHeight;
                    $('html,body').stop(true, false).animate({
                        scrollTop: height
                    }, 700);
                })
            }
        })
    }

    const getContentData = () => {
        Promise.all([
            api.getSubmenu(385),
            api.getRows({ categoryId: 389, content_en: 1, content: 1, title_en: 1 }),
            api.getNewRos({ id: 29 }),
        ]).then(res => {
            let data1 = {
                list: res[0].data,
                isPc: window.innerWidth > 991 ? 1 : 0
            };
            let data2 = { list: res[1].data };
            let data3 = res[2].data[0];
            data3.image = window.innerWidth > 992 ? res[2].data[0].big_img : res[2].data[0].img_url;
            render('index_productBoxTmp', 'index_productBox', data1);
            render('index_conceptBoxTmp', 'index_conceptBox', data2);
            render('index_globalBoxTmp', 'index_globalBox', data3);
            new WOW({live:true}).init();
            language();
        })
    }

    (async () => {
        getBannerData();
    })();

})


// WEBPACK FOOTER //
// ./src/entry/index.js